export const urlcode = 'https://kfapi.sjhlwyy.com'//正式


// export const urlcode = 'http://192.168.40.19:1083/sjkf'  //fqf
export default {urlcode}



// WEBPACK FOOTER //
// ./src/config.js